export { default } from './AnonHero';
